const USER_ROLES = {
  ADMIN: "admin",
  MEMBER: "member",
  ASSOCIATIVE: "associative",
};

export { USER_ROLES };
